<form #newModule="ngForm" (ngSubmit)="createupdatepackage()" class="course-form mb-0">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-layer-group" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{package.id ? 'Edit Package' : 'Create New Package'}}</h1>
      <p class="cf-head__sub">Group courses together and sell them as one</p>
    </div>
    <div class="cf-head__actions">
      <button class="btn btn--warning m-0" type="button" routerLink="/user/schoolhome">Cancel</button>
      <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit">
        <i class="fas fa-save" aria-hidden="true"></i> Save Package
      </button>
    </div>
  </header>

  <section class="cf-card">
    <div class="cf-card__split">
      <div>
        <h2 class="cf-card__title">Package Image</h2>
        <p class="cf-card__hint">Add an image to make your package stand out</p>
      </div>
      <div class="cf-image">
        <div *ngIf="logoimg.style.display === 'none'" class="cf-image__empty">
          <i class="far fa-image" aria-hidden="true"></i>
          <span>No image added</span>
          <small>Recommended {{settings.moduleImageWidth}} x {{settings.moduleImageHeight}}px</small>
        </div>
        <img #logoimg src="{{package.imageUrl}}" alt="Package image" class="cf-image__preview" style="display: none;">
        <button (click)="logo.click()" type="button" id="courseHeaderImgLabel" class="btn m-0 mt-2">
          <i class="fa fa-plus"></i> Add Image
        </button>
        <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" name="logo" accept="image/*"
          aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
      </div>
    </div>
  </section>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-file-alt" aria-hidden="true"></i> Package Details</h2>

    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label class="legend" for="schoolname">Package Name <span class="requiredfield">*</span></label>
        <input type="text" [(ngModel)]="package.name" #name name="name" maxlength="200" required class="text-field"
          id="schoolname">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Package name"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">The name students see on the package page and in the package list. Up to 200 characters.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="amountPerStudent">Price</label>
        <input type="number" [(ngModel)]="package.amountPerStudent" #price name="amountPerStudent" min="0"
          class="text-field" id="amountPerStudent">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Price"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">What a student pays for the whole package, in your school's currency. Leave it empty or 0 to make the package free.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="accessDays">Access Days</label>
        <input type="number" [(ngModel)]="package.accessdays" #accessdays name="accessdays" min="0" class="text-field"
          id="accessDays">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Access days"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">How many days a student keeps every course in the package, counted from the day they enroll. 0 means access never expires. It replaces the access days set on the individual courses.</p>
        </div>
      </div>
    </div>

    <div class="cf-description">
      <div class="fieldset fieldset--note">
        <label class="legend z-1">Package Description <span class="requiredfield">*</span></label>
        <!-- Bound with ngModel so `required` applies. It previously had a bare `required`
             and no binding at all, so a package could be saved with no description. -->
        <quill-editor #description name="description" required [(ngModel)]="package.description"
          placeholder="Describe what this package includes..."></quill-editor>
      </div>
      <aside class="cf-tips">
        <h3><i class="far fa-lightbulb" aria-hidden="true"></i> Tips for a great description</h3>
        <ul>
          <li>List the courses it includes</li>
          <li>Explain who it suits</li>
          <li>Say why it is better value together</li>
          <li>Keep it short</li>
        </ul>
      </aside>
    </div>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-layer-group" aria-hidden="true"></i>
      <span>
        <strong>After saving, you'll be able to add courses to this package.</strong><br>
        You can always edit these details later.
      </span>
    </span>
    <span class="cf-footer__actions">
      <button class="btn btn--warning m-0" type="button" routerLink="/user/schoolhome">Cancel</button>
      <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit">Save &amp; Continue</button>
    </span>
  </div>
</form>

  <!-- <div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-add-external-media #addExternalMediaComponent></app-add-external-media>
        </div>
        <div class="modal-footer justify-content-center gap-1.5">
          <button type="button" class="btn m-0" (click)="externalMediaSelected()" [disabled]="!addExternalMediaComponent.iframeurl">Ok</button>
          <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
        </div>
      </div>
    </div>
  </div> -->
  